import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { MeteorObservable, ObservableCursor } from 'meteor-rxjs';
import { NavParams, ModalController, Platform, AlertController } from 'ionic-angular';
import * as moment from 'moment';
import { Project, Update } from 'api/models';
import { Updates } from 'api/collections';
// import { getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import { HttpService } from '../../services/httpService';
import * as XLSX from 'xlsx';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { daysSinceOAEpoch } from '../../services/p6calendar';
import { SharedService } from '../../services/sharedService';

type DurationT = 'day' | 'hour' | void;
type UnitT = 'day' | 'hour' | void;
type DateFormatT = 'M/d/yyyy' | 'monthDayYear' | 'dayMonthYear' | 'yearMonthDay' | void;
Date.prototype['stdTimezoneOffset'] = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

Date.prototype['isDstObserved'] = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
}
function pad(num) {
  var s = "000000000" + num;
  return s.substr(s.length-3);
}

function createCompositeString(units: UnitT, duration: DurationT, dateFormat: DateFormatT): string {
  const showAs = 'ShowAsPercentage=0';
  const currencyFormat = 'CurrencyFormat=Dollar';

  let durationQtType: string;
  if (duration === 'day') {
    durationQtType = 'DurationQtyType=QT_Day';
  } else if (duration === 'hour'){
    durationQtType = 'DurationQtyType=QT_Hour';
  } else {
    throw new Error('Invalid duration: '+duration);
  }

  let dateFormatComponent='DateFormat=M/d/yyyy';

  let smallScaleQtType: string;
  if (units === 'day') {
    smallScaleQtType = 'SmallScaleQtyType=QT_Day';
  } else if (units === 'hour') {
    smallScaleQtType = 'SmallScaleQtyType=QT_Hour';
  } else {
    throw new Error('Invalid units: '+units);
  }
  const linebreakCharacter = `
`;
  return durationQtType +linebreakCharacter+ showAs +linebreakCharacter+ smallScaleQtType +linebreakCharacter+ dateFormatComponent +linebreakCharacter+ currencyFormat;
}
@Component({
  selector: 'archived-updates',
  templateUrl: 'archived-updates.html'
})
export class ArchivedUpdates implements OnInit {
  project?: Project | void;
  archivedUpdates: Update[];
  units: UnitT = "hour";
	duration: DurationT = "day";
  dateFormat: DateFormatT = 'M/d/yyyy';
  updatePeriodTypesToggle:any={};
  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    private platform: Platform,
    private alertCtrl: AlertController,
    private httpService: HttpService,
    private sharedService: SharedService,
    public projectService: ProjectService
  ) {

  }
  ngOnInit(): void {
    MeteorObservable.autorun().subscribe(() => {
      const projectIdReactive = this.navParams.get('projectIdReactive');
      const projectId =  projectIdReactive && projectIdReactive.get();
      this.project = this.projectService.getProject(projectId);

      if (this.project) {
        this.archivedUpdates = Updates.find({
          projectId: this.project._id,
          archived: true,
        }, {
          sort: {completionDate: -1},
        }).fetch();

        this.updatePeriodTypesToggle={};
        this.archivedUpdates.forEach(update=>{
          this.updatePeriodTypesToggle[update._id]=false;
        });
        console.log('archived: ' + this.project)
      } else {

        this.archivedUpdates = undefined;
        console.log('archived: ' + this.project)
      }
    });
  }

  canDownload(): boolean {
    return this.platform.is('core'); // core means desktop
  }

  showError(title: string, message: string): void {
    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message,
      title,
    });

    alert.present();
  }

  async exportUpdateZip(update: Update, pcOrRd:boolean){
    this.updatePeriodTypesToggle[update._id]=pcOrRd//false =rd, true = pc
    const zip = new JSZip();
    const fileNameAndValues = {
      ...(await this.exportUpdate(1, update)),
      ...(await this.exportUpdate(2, update))
    };
    Object.keys(fileNameAndValues).forEach(key=>{
      zip.file(key, fileNameAndValues[key])
    })

    const updatePeriodTypeName = !this.updatePeriodTypesToggle[update._id] ? "rd":"pc";
    const zipName = `${update.projectRow['proj_id']}-${pad(update['number'])}-${updatePeriodTypeName}.zip`;
    return zip.generateAsync({type:"blob"})
      .then(function (file) {
          saveAs(file, zipName);
      });
  }

  exportUpdate(stepNum: null|1|2, update: Update) {
    if (!(stepNum === null || stepNum === 1 || stepNum === 2)) {
      throw new Error('Invalid stepNum');
    }

    if (!update) {
      throw new Error('Invalid update');
    }
    /*
    return MeteorObservable.call(
      'exportUpdate',
      update._id,
      this.dateFormat,
      this.duration,
      this.units,
      this.updatePeriodTypesToggle[update._id]
    ).toPromise().then((dataRows: Array<any>)=>{
      const taskDataSheet: XLSX.WorkSheet = this.makeTaskDataSheet(stepNum, dataRows, this.updatePeriodTypesToggle[update._id]);
      const userDataSheet: XLSX.WorkSheet = this.makeUserDataSheet();
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, taskDataSheet, 'TASK');
      XLSX.utils.book_append_sheet(wb, userDataSheet, 'USERDATA');
      // save to file
      const fileName = this.getFileName(update, stepNum);
      let fileNameAndValue={};
      const xlsxWrite = XLSX.write(wb, { bookType:'xlsx', bookSST:false, type:'array' });
      fileNameAndValue[fileName]=new Blob(
        [xlsxWrite],
        {type:"application/octet-stream"}
      );
      return fileNameAndValue;
    });
    */

    return this.httpService.MeteorCall(
      'exportUpdate',
      update._id,
      this.dateFormat,
      this.duration,
      this.units,
      this.updatePeriodTypesToggle[update._id]
    ).then((dataRows: any)=>{
      console.log('exportUpdate',
      update._id,
      this.dateFormat,
      this.duration,
      this.units,
      this.updatePeriodTypesToggle[update._id])

      console.log(dataRows)
      const taskDataSheet: XLSX.WorkSheet = this.makeTaskDataSheet(stepNum, dataRows, this.updatePeriodTypesToggle[update._id]);
      const userDataSheet: XLSX.WorkSheet = this.makeUserDataSheet();
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, taskDataSheet, 'TASK');
      XLSX.utils.book_append_sheet(wb, userDataSheet, 'USERDATA');
      // save to file
      const fileName = this.getFileName(update, stepNum);
      let fileNameAndValue={};
      if(wb.Sheets.TASK.D2.v==="Actual Start"){
        Object.keys(wb.Sheets.TASK).filter(key=>key!="!ref").forEach(key=>{
          if(key.includes("D") && Number(key.split("D")[1]) > 2){
            wb.Sheets.TASK[key]={
              t: 'n',
              v: Math.round(daysSinceOAEpoch(moment(wb.Sheets.TASK[key].v).toDate()))+8/24,// + ((new Date())['isDstObserved']()?0:1/24),
              z: 'mm/dd/yyyy HH:MM',
              w: (wb.Sheets.TASK[key].v).toString().slice(0, -3)
            }
          }
          if(key.includes("E") && Number(key.split("E")[1]) > 2){
            wb.Sheets.TASK[key]={
              t: 'n',
              v: Math.round(daysSinceOAEpoch(moment(wb.Sheets.TASK[key].v).toDate()))+17/24,// + ((new Date())['isDstObserved']()?0:1/24),
              z: 'mm/dd/yyyy HH:MM',
              w: (wb.Sheets.TASK[key].v).toString().slice(0, -3)
            }
          }
        })
      }
      const xlsxWrite = XLSX.write(wb, { bookType:'xlsx', bookSST:false, type:'array' });
      fileNameAndValue[fileName]=new Blob(
        [xlsxWrite],
        {type:"application/octet-stream"}
      );
      return fileNameAndValue;
    });
  }

  getFileName(update:Update, stepNum: null|1|2, type=".xlsx"){
    const updatePeriodTypeName = !this.updatePeriodTypesToggle[update._id] ? "rd":"pc";
    return `${update.projectRow['proj_id']}-${pad(update['number'])}-${updatePeriodTypeName}-${stepNum}.xlsx`;
  }

  makeTaskDataSheet(stepNum: null|1|2, dataRows: Array<any>, isPercentComplete?:boolean): XLSX.WorkSheet {
    const remainingDurationField = isPercentComplete ? 'drtn_complete_pct' :'remain_drtn_hr_cnt';
    const headerFields = [
      'task_code',
      'status_code',
      'wbs_id',
      'act_start_date',
      'act_end_date',
      remainingDurationField,
      'delete_record_flag'
    ];
    const COLINDEX_REMAINING_DURATION = headerFields.indexOf(remainingDurationField);
    const COLINDEX_ACTUAL_START = headerFields.indexOf('act_start_date');
    const COLINDEX_ACTUAL_FINISH = headerFields.indexOf('act_end_date');

    let remainingDurationLabel;
    if(isPercentComplete){
      remainingDurationLabel = 'Duration % Complete';
    } else if (this.duration === 'day') {
      remainingDurationLabel = 'Remaining Duration(d)';
    } else if (this.duration === 'hour') {
      remainingDurationLabel = 'Remaining Duration(h)';
    } else {
      console.warn('Invalid duration:', this.duration);
      this.showError('Invalid duration', 'Please select a valid duration');
      return;
    }

    const secondRow = [
      'Activity ID',
      'Activity Status',
      'WBS Code',
      'Actual Start',
      'Actual Finish',
      remainingDurationLabel,
      'Delete This Row'
    ];

    const rows = [headerFields, secondRow, ...dataRows];
    return XLSX.utils.aoa_to_sheet(rows.map(row => {
      return row.filter((column, colIndex) => {
        if (stepNum === 1) {
          return !(colIndex === COLINDEX_REMAINING_DURATION);
        } else if (stepNum === 2) {
          return !(colIndex === COLINDEX_ACTUAL_START || colIndex === COLINDEX_ACTUAL_FINISH);
        }
        return true;
      });
    }));
  }

  makeUserDataSheet(): XLSX.WorkSheet {
    if (!this.units || !this.duration || !this.dateFormat) {
      throw new Error('Invalid input');
    }

    const userDataRowOne  = [
      'user_data'
    ];

    const userDataRowTwo = [
      'UserSettings Do Not Edit'
    ];

    const compositeStringArray = [createCompositeString(this.units, this.duration, this.dateFormat)];

    const userDataSheet = [
      userDataRowOne,
      userDataRowTwo,
      compositeStringArray,
    ];

    return XLSX.utils.aoa_to_sheet(userDataSheet);
  }


}



// WEBPACK FOOTER //
// ./src/pages/archived-updates/archived-updates.ts